import { Icon } from "@juiceforward/narrative-player";

interface MockUser {
  id: string;
  name: string;
  email: string;
  role: "admin" | "editor";
  status: "active" | "inactive";
  lastLogin: string;
  narrativesCreated: number;
}

const mockUsers: MockUser[] = [
  {
    id: "user_1",
    name: "Jennifer Martinez",
    email: "jmartinez@teachingstrategies.com",
    role: "admin",
    status: "active",
    lastLogin: "2026-02-18",
    narrativesCreated: 12,
  },
  {
    id: "user_2",
    name: "Michael Thompson",
    email: "mthompson@teachingstrategies.com",
    role: "editor",
    status: "active",
    lastLogin: "2026-02-17",
    narrativesCreated: 8,
  },
  {
    id: "user_3",
    name: "Amanda Chen",
    email: "achen@teachingstrategies.com",
    role: "editor",
    status: "active",
    lastLogin: "2026-02-16",
    narrativesCreated: 15,
  },
  {
    id: "user_4",
    name: "David Rodriguez",
    email: "drodriguez@teachingstrategies.com",
    role: "editor",
    status: "inactive",
    lastLogin: "2026-01-20",
    narrativesCreated: 5,
  },
];

export const UsersView = () => {
  return (
    <div className="space-y-6">
      {/* Users Table */}
      <div className="bg-[var(--admin-surface)] border border-[var(--admin-border)] rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-[var(--admin-surface-raised)] border-b border-[var(--admin-border)]">
            <tr>
              <th className="text-left px-6 py-4 text-sm font-medium text-[var(--admin-text-muted)]">
                User
              </th>
              <th className="text-left px-6 py-4 text-sm font-medium text-[var(--admin-text-muted)]">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {mockUsers.map((user) => (
              <tr
                key={user.id}
                className="border-b border-[var(--admin-border)] hover:bg-[var(--admin-surface-raised)] transition-colors"
              >
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-emerald-500/20 rounded-full flex items-center justify-center">
                      <Icon icon="user" className="text-emerald-400" />
                    </div>
                    <div>
                      <div className="font-medium">{user.name}</div>
                      <div className="text-sm text-[var(--admin-text-subtle)]">
                        {user.email}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <button
                    className="text-red-400 hover:text-red-300 transition-colors"
                    title="Delete User"
                  >
                    <Icon icon="trash" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
